import { round } from 'lodash';
import { toDisplayValue } from '@/components/sliders/sliderUtils';
import { MinMax } from '@/types/metric';
import { FormattedMetricDistributionPercentiles } from '@/utils/metrics';

export const getSafeNinetyFifthPercentile = (
  fifthPercentile: number | string,
  ninetyFifthPercentile: number | string,
): number => {
  const ninetyFifthPercentileFallback = Number(fifthPercentile) + 0.001;
  return ninetyFifthPercentile === fifthPercentile ? ninetyFifthPercentileFallback : Number(ninetyFifthPercentile);
};

/** Return raw (not display) min/max limits from percentiles. */
export const getPercentileLimits = (metricPercentiles: FormattedMetricDistributionPercentiles): MinMax => {
  const fifthPercentile = metricPercentiles.percentiles[5].value;
  const ninetyFifthPercentile = metricPercentiles.percentiles[95].value;
  const safeNinetyFifthPercentile = getSafeNinetyFifthPercentile(fifthPercentile, ninetyFifthPercentile);

  return {
    min: fifthPercentile,
    max: safeNinetyFifthPercentile,
  };
};

export const currentFormattedMinMaxSliderValues = (
  activeMetric: string,
  customLimits: Record<string, MinMax>,
  metricPercentiles: FormattedMetricDistributionPercentiles,
  isPercentage: boolean,
) => {
  const { min: fifthPercentile, max: ninetyFifthPercentile } = getPercentileLimits(metricPercentiles);

  const rawMin = customLimits[activeMetric]?.min ?? fifthPercentile;
  const rawMax = customLimits[activeMetric]?.max ?? ninetyFifthPercentile;

  return {
    currentMin: toDisplayValue(rawMin, isPercentage),
    currentMax: toDisplayValue(rawMax, isPercentage),
  };
};

/**
 * Round to the given number of decimal places, then return a string formatted to display that number of decimal
 * places. This will include trailing 0s if necessary.
 */
export const roundToFixed = (value: number, precision: number): string => round(value, precision).toFixed(precision);
